module.exports = __webpack_public_path__ + "static/media/AmazonTicketRaised.fc1154c0.svg";